import { render } from "./Received_Orders.vue?vue&type=template&id=f2fe6242&scoped=true"
import script from "./Received_Orders.vue?vue&type=script&lang=js"
export * from "./Received_Orders.vue?vue&type=script&lang=js"

import "./Received_Orders.vue?vue&type=style&index=0&id=f2fe6242&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2fe6242"]])

export default __exports__